import environments from "@/environments";
import { ApiFileResult, useApi } from "@/hooks/useApi";

export const useMapImageApi = () => {
  const api = useApi();

  const fetchMapImage = async (mapImageId: number): Promise<Blob | undefined> => {
    const endpoint = `${environments.API_BASE_URI}/map_images/files/${mapImageId}`;
    const result = await api.get<Blob | ApiFileResult>(endpoint);
    if (result && "data" in result && result.data instanceof Blob) {
      return result.data;
    }
    return result as Blob | undefined;
  };

  return { fetchMapImage } as const;
};
